import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useEffect, useState } from "react";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const [navItems, setNavItems] = useState([]);

    useEffect(() => {
        const fetchMenuItems = async () => {
            const menuItems = await menuItem();
            setNavItems(menuItems.items);
        };

        fetchMenuItems();
    }, []);

    return (
        <>
            {navItems.length > 0 ? (
                navItems.map((item) => {
                    switch (item?.type) {
                        case 'group':
                            return <NavGroup key={item?.id} item={item} />;
                        default:
                            return (
                                <Typography key={item?.id} variant="h6" color="error" align="center">
                                    Menu Items Error
                                </Typography>
                            );
                    }
                })
            ) : (
                <Typography variant="h6" color="error" align="center">
                    Loading menu items...
                </Typography>
            )}
        </>
    );
};

export default MenuList;
